import axios from 'axios';
import { store } from 'plugins/store/store';
import { userLogoutActionCreator } from 'plugins/store/reducers/auth.reducer';

const API_URL = '/api/v1/auth/';

const login = async (username, password) => {
	return await axios
		.post(API_URL + 'signin', {
			username,
			password,
		});
};

const authorize = async (username, password) => {
	return await axios
		.post(API_URL + 'authorize', {
			username,
			password,
		});
};

const checkServerHealth = () => axios.get('https://localhost:8089');

const changePassword = (data) => axios.post(`${API_URL}change-password`, data);

const logout = () => {
	store.dispatch(userLogoutActionCreator());
}

const getCurrentUser = () => {
	return store.getState().auth.auth;
};

const getLocked = () => {
	return store.getState().auth.locked;
};

export default {
	login,
	logout,
	authorize,
	checkServerHealth,
	getCurrentUser,
	getLocked,
	changePassword,
};
